import React from 'react';
import styles from './ui.module.css';

interface PageFrameProps {
  /** A <PageHeader />, rendered above the stack of cards. */
  header: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Wraps a page: the header on the canvas, then a stack of cards below it.
 * Gives every page the same width, gutter and minimum height, so moving
 * between screens never makes the layout jump.
 */
const PageFrame: React.FC<PageFrameProps> = ({ header, children }) => (
  <div className={styles.page}>
    {header}
    <div className={styles.stack}>{children}</div>
  </div>
);

export default PageFrame;
